import { render, staticRenderFns } from "./u-radios.vue?vue&type=template&id=5b66196a&scoped=true&"
import script from "./u-radios.vue?vue&type=script&lang=js&"
export * from "./u-radios.vue?vue&type=script&lang=js&"
import style0 from "./u-radios.vue?vue&type=style&index=0&id=5b66196a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66196a",
  null
  
)

export default component.exports